<section class="flex items-center justify-center px-4 py-8 sm:px-8 sm:py-12">
  <div
    class="box bg-white rounded-lg flex flex-col items-center justify-center w-full max-w-sm p-6 sm:p-10 md:p-16 shadow-md"
  >
    <h1 class="title text-2xl sm:text-3xl font-medium text-center">
      {{ appName }}
    </h1>
    <p class="text-center mt-3 text-sm sm:text-base">
      Your account is authenticated but does not have the required role.
    </p>
    <button
      (click)="logout()"
      class="button button-primary w-full mt-10"
      type="submit"
    >
      Logout
    </button>
  </div>
</section>
